import {Component, computed, input} from '@angular/core';
import {SafeHtmlPipe} from '@frontend/shared';

// CMS text pasted from Word/AI joins every word with a non-breaking space, which makes a whole
// paragraph behave like a single unbreakable word and pushes the layout past the viewport.
const NON_BREAKING_SPACE = /&nbsp;|&#160;|&#xa0;|\u00a0/gi;

@Component({
  selector: 'app-safe-html-output',
  imports: [SafeHtmlPipe],
  template: `<p
    class="safe-html"
    [innerHTML]="breakableHtml() | safeHtml"
    [attr.data-testid]="testDataId()"
  ></p>`,
})
export class SafeHtmlComponent {
  readonly html = input<string | null | undefined>('');
  readonly testDataId = input<string | null | undefined>('');

  readonly breakableHtml = computed(() => (this.html() ?? '').replace(NON_BREAKING_SPACE, ' '));
}
